import {
  SET_MAP_FILTER,
  SET_MAP_DATE_FILTER_TYPE,
  SET_MAP_USER_GROUP_FILTER,
  SET_MAP_DATE_DATE_RANGE,
  SET_MAP_LABEL_FILTER,
} from 'constants/actions';
import { combineReducers } from '@reduxjs/toolkit';

const map = (state = {}, action = {}) => {
  switch (action.type) {
    case SET_MAP_FILTER:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

const dateFilterType = (state = null, action = {}) => {
  switch (action.type) {
    case SET_MAP_DATE_FILTER_TYPE:
      return action.payload === state ? null : action.payload;

    default:
      return state;
  }
};

const customDateRange = (state = null, action = {}) => {
  switch (action.type) {
    case SET_MAP_DATE_DATE_RANGE:
      return action.payload;

    case SET_MAP_DATE_FILTER_TYPE:
      return null;

    default:
      return state;
  }
};

const userGroup = (state = null, action = {}) => {
  switch (action.type) {
    case SET_MAP_USER_GROUP_FILTER:
      return action.payload;

    default:
      return state;
  }
};

const selectedLabels = (state = null, action = {}) => {
  switch (action.type) {
    case SET_MAP_LABEL_FILTER:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  dateFilterType,
  map,
  userGroup,
  customDateRange,
  selectedLabels,
});
